import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { FN_CANVAS__draw_badge } from './FN_CANVAS__draw_badge';
import { FN_CANVAS__draw_checker_board } from './FN_CANVAS__draw_checker_board';
import { FN_CANVAS__draw_fit_image } from './FN_CANVAS__draw_fit_image';
import { FN_CANVAS__draw_placeholder } from './FN_CANVAS__draw_placeholder';
import { PROPS__image_bounds } from './PROPS__image_bounds';
import { PROPS__slider_mode_params } from './PROPS__slider_mode_params';

export function FN_CANVAS__apply_image_compare__slider({ ctx, width, height, image_a: imgA, image_b: imgB, position_split, fitAR }: PROPS__slider_mode_params) {
  const is_image_a_stub: boolean = imgA === ENUM__html_ref_stub.IMAGE;
  const is_image_b_stub: boolean = imgB === ENUM__html_ref_stub.IMAGE;

  const targetAspectB: number = fitAR && !is_image_a_stub ? imgA.naturalWidth / imgA.naturalHeight : NaN;

  // Determine active reference image to calculate common bounds
  let image_for_bounds: HTMLImageElement = ENUM__html_ref_stub.IMAGE;
  if (!is_image_a_stub) image_for_bounds = imgA;
  else if (!is_image_b_stub) image_for_bounds = imgB;

  const calculatedBounds: PROPS__image_bounds = FN_CANVAS__draw_fit_image(ctx, image_for_bounds, 0, 0, width, height, targetAspectB, true);

  // Fallback to canvas dimensions if bounds returning NaN
  const bounds: PROPS__image_bounds = isNaN(calculatedBounds.x) ? { x: 0, y: 0, w: width, h: height } : calculatedBounds;

  const lineX: number = width * position_split;

  // 1. Render Background & Image B (Right side)
  ctx.save();
  ctx.beginPath();
  ctx.rect(lineX, 0, width - lineX, height);
  ctx.clip();

  // Draw background for B (use 'black' or call drawCheckerboard)
  FN_CANVAS__draw_checker_board(ctx, 0, 0, width, height);
  // For solid black instead, use:
  // ctx.fillStyle = '#000000'; ctx.fillRect(0, 0, width, height);

  if (is_image_b_stub) {
    FN_CANVAS__draw_placeholder(ctx, bounds);
  } else {
    FN_CANVAS__draw_fit_image(ctx, imgB, 0, 0, width, height, targetAspectB);
  }
  ctx.restore();

  // 2. Render Background & Image A (Left side)
  ctx.save();
  ctx.beginPath();
  ctx.rect(0, 0, lineX, height);
  ctx.clip();

  // Draw background for A
  FN_CANVAS__draw_checker_board(ctx, 0, 0, width, height);
  // For solid black instead, use:
  // ctx.fillStyle = '#000000'; ctx.fillRect(0, 0, width, height);

  if (is_image_a_stub) {
    FN_CANVAS__draw_placeholder(ctx, bounds);
  } else {
    FN_CANVAS__draw_fit_image(ctx, imgA, 0, 0, width, height);
  }
  ctx.restore();

  // 3. Render Divider Line
  ctx.strokeStyle = '#48ff84';
  ctx.lineWidth = 2;
  ctx.shadowColor = 'rgba(72, 255, 132, 0.55)';
  ctx.shadowBlur = 6;
  ctx.beginPath();
  ctx.moveTo(lineX, 0);
  ctx.lineTo(lineX, height);
  ctx.stroke();
  ctx.shadowBlur = 0;

  // 4. Render Badges
  FN_CANVAS__draw_badge(ctx, 'A', 20, 20);
  FN_CANVAS__draw_badge(ctx, 'B', width - 20, 20);
}
